/** True when the user entered a price (including 0 MAD offers). */
export function hasExplicitPrice(price) {
  return price !== '' && price !== undefined && price !== null;
}

/** Use entered price when set (0 allowed); otherwise fall back to default price. */
export function resolveItemPrice(price, fallbackPrice) {
  return hasExplicitPrice(price) ? Number(price) : Number(fallbackPrice);
}

/** Controlled input value — keeps 0 visible instead of clearing the field. */
export function priceInputValue(price) {
  return hasExplicitPrice(price) ? price : '';
}
